import script from "./BaseDrawer.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseDrawer.vue?vue&type=script&setup=true&lang=js"

import "./BaseDrawer.vue?vue&type=style&index=0&id=db26a94e&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/shark1x2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-db26a94e"]])

export default __exports__